// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"PredictiveTable_tableContainer__11LYq","tableText":"PredictiveTable_tableText__2WQno"};